import { h } from "preact";
import { useEffect } from "preact/hooks";
import { observer } from "mobx-react";
import FieldError from "./FieldError";
import FieldLabel from "./FieldLabel";
function PhoneField(props) {
    const { controller, name, label, autocomplete, placeholder, required = false, disabled = false, autofocus = false, dataFieldId, } = props;
    const handleChange = (event) => {
        const value = event.target.value;
        controller.change(value);
    };
    // TODO: UI field that allows to set the country?
    useEffect(() => {
        controller.setCountry(Skubacz.configuration.country);
    }, []);
    const hasError = controller.isTouched && controller.isInvalid;
    const isSuccess = controller.isTouched && controller.isValid;
    return (h("div", { class: `form-group form-field m-form__group  ${hasError ? "has-error" : ""} ${isSuccess ? "success" : ""} ${disabled ? "is-disabled" : ""}`, "data-field-id": dataFieldId },
        h(FieldLabel, { isRequired: required, htmlFor: name }, label),
        h("input", { id: name, name: name, onChange: handleChange, onBlur: () => controller.blur(), value: controller.value, autofocus: autofocus, autocomplete: autocomplete, placeholder: placeholder, required: required, disabled: disabled, type: "tel", class: "form-control" }),
        hasError && h(FieldError, { errors: controller.errors })));
}
export default observer(PhoneField);
